import { useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type { IAppsSDKsFilterItem } from "../../../types/commonFiltersDto";
import type { IAppsSDKsFilterDescriptionDto } from "../../../types/descriptionDto";
import SdkModal from "../../modals/SdkModal/SdkModal";

import { ADD_BUTTON_TOOLTIP_MAX_WIDTH, StyledAddButtonContainer, StyledEmptyText } from "./styles";

const AppSdkFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseModelProps<IAppsSDKsFilterItem[], IAppsSDKsFilterDescriptionDto>) => {
    const { translate } = useTranslate();

    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const handleOpenModal = () => {
        setIsOpenModal(true);
    };

    const renderAddButton = () => {
        const button = (
            <IconButton
                type="flat"
                iconName="add"
                onClick={handleOpenModal}
                dataAutomation="technologies-filter-button-add"
            >
                {translate(`si.find_apps.filters.sdk.button.add`)}
            </IconButton>
        );

        if (value && value?.length > 0) {
            return (
                <PlainTooltip
                    tooltipContent={translate(`si.find_apps.filters.sdk.button.add.tooltip`)}
                    maxWidth={ADD_BUTTON_TOOLTIP_MAX_WIDTH}
                >
                    <div>{button}</div>
                </PlainTooltip>
            );
        }

        return button;
    };

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: IAppsSDKsFilterItem) => {
        onFilterUpdate(value ? [...value, item] : [item]);
        setIsOpenModal(false);
    };

    return (
        <>
            <SdkModal
                isOpen={isOpenModal}
                selected={null}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
                options={filter.options}
                value={value}
            />

            <StyledEmptyText isHidden={!!(value && value?.length > 0)}>
                {translate(`si.find_apps.filters.sdk.empty_text`)}
            </StyledEmptyText>
            <StyledAddButtonContainer>{renderAddButton()}</StyledAddButtonContainer>
        </>
    );
};

export default AppSdkFilter;
